module.exports = __webpack_public_path__ + "img/s8sLogo5.cc7cc8b3.png";